import api from './api';

export const authService = {
  login: async (identifier, password) => {
    // L'identifier peut être un email ou un téléphone
    const response = await api.post('/auth/login', { 
      identifier, 
      password 
    });
    return response.data;
  },

  register: async (userData, profilePhotoFile) => {
    const formData = new FormData();
    
    // Ajouter tous les champs utilisateur
    Object.keys(userData).forEach(key => {
      if (userData[key] !== undefined && userData[key] !== null) {
        formData.append(key, userData[key]);
      }
    });
    
    // Ajouter le fichier photo
    if (profilePhotoFile) {
      formData.append('profilePhoto', profilePhotoFile);
    }
    
    const response = await api.post('/auth/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    return JSON.parse(localStorage.getItem('user') || 'null');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};
